module.exports = (__webpack_require__(19385))(4484);